import { useContext } from 'react';

import { useRole } from '../../../../common/hooks/useRole';
import { SupplierSubscriptionPlansContext } from '../../../../supplier-subscription-plans/SupplierSubscriptionPlansContext';

import { SupplierGroupPlanSectionContent } from './SupplierGroupPlanSectionContent';

interface SupplierGroupPlanSectionProps {
    supplierGroupId: string;
}

export const SupplierGroupPlanSection = ({ supplierGroupId }: SupplierGroupPlanSectionProps) => {
    const role = useRole();
    const plans = useContext(SupplierSubscriptionPlansContext);
    if (role.isSuperAdmin()) {
        return <SupplierGroupPlanSectionContent supplierGroupId={supplierGroupId} />;
    }
    return role.isSupplier() && plans?.canViewPlans ? (
        <SupplierGroupPlanSectionContent supplierGroupId={supplierGroupId} onViewPlans={plans.openPlans} />
    ) : null;
};
